export const getWithdrawalPlannerEnums = (state) => state.withdrawalPlannerEnums